import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft, Users, DollarSign, Video, ShoppingBag, BookOpen, Check, X, Upload, TrendingUp, Crown, Lock, Unlock, Settings, RefreshCw, Globe, Edit3, FileSpreadsheet, AlertCircle, Download, Youtube, Plus, Layers, Calendar, Flag, Star, Trash2, Gift, Ban, UserX, UserCheck, CheckCircle, ShieldCheck, Clock, PartyPopper, Archive } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Switch } from '../ui/switch';
import VideoScanCard from './VideoScanCard';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * LMS Content tab.
 *
 * Lifted out of AdminPanel.js during the Phase 2 frontend split (Wave 4).
 * Pure presentational — receives parent state + handlers via props.
 */
export default function ContentTab(props) {
  const { user, navigate, getAuthHeader, fetchAllData, fileInputRef, users, setUsers, userSearch, setUserSearch, filteredUsers, pendingFounders, founderSettings, setFounderSettings, founderSeatsRemaining, updateFounderSettings, toggleFounderEnrollment, toggleFoundingMember, suspendUser, archiveUser, permanentlyDeleteUser, changeUserTier, sales, pendingSales, pendingListingSales, handleVerifySale, handleVerifyListingSale, handleUnverifyListingSale, handleCancelListingSale, commissionDashboard, promoCodes, newPromo, setNewPromo, createPromoCode, deletePromoCode, promoToDelete, setPromoToDelete, potData, setPotData, updatePot, advertisers, pendingVideos, pendingLibraryVideos, handleBatchApproveVideos, handleVideoReview, handleLibraryVideoReview, moveDownlineData, setMoveDownlineData, featuredMembers, selectedUserToFeature, setSelectedUserToFeature, featuredText, setFeaturedText, handleAddFeaturedMember, handleRemoveFeaturedMember, tierFeatures, editingTier, setEditingTier, editFeatures, setEditFeatures, startEditingTier, saveTierFeatures, customTiers, showTierForm, setShowTierForm, newTier, setNewTier, tierFeaturesInput, setTierFeaturesInput, handleCreateTier, handleDeleteTier, pendingServices, flaggedServices, handleApproveService, handleFlagService, handleDeleteService, edirectoryStatus, syncingEdir, syncEdirectory, importedTransactions, importing, importResult, handleFileSelect, downloadSampleCSV } = props;

  return (
    <div className="space-y-4" data-testid="content-tab">
      <div className="flex justify-between items-center mb-4">
                    <h2 className="text-2xl font-playfair font-bold text-foreground">Learning Management</h2>
                    <Link to="/courses">
                      <Button className="bg-primary text-primary-foreground hover:bg-primary/90" data-testid="manage-courses-btn">
                        <BookOpen className="w-4 h-4 mr-2" /> Manage Courses
                      </Button>
                    </Link>
                  </div>
                  <VideoScanCard getAuthHeader={getAuthHeader} />
                  <div className="wm-card p-6 rounded-lg border border-border space-y-3">
                    <p className="text-muted-foreground text-sm">
                      Looking for the member &quot;Get Started&quot; welcome pop-up? It now has its own spot:
                      <span className="text-gold"> Content → Onboarding</span> in the admin menu.
                    </p>
                  </div>

                  <div className="wm-card p-6 rounded-lg border border-border space-y-3">
                    <p className="text-muted-foreground text-sm">
                      Course authoring lives in the LMS — head to <Link to="/courses" className="text-gold hover:underline">/courses</Link> to add modules, lessons,
                      and videos. Each module gets its own shareable URL so members can deep-link directly to a video.
                    </p>
                    <p className="text-xs text-muted-foreground">
                      The legacy <code className="text-gold">educational_content</code> collection has been migrated into the LMS.
                    </p>
                    <div className="pt-2">
                      <Link to="/courses/new">
                        <Button variant="outline" data-testid="new-course-btn">
                          <Plus className="w-4 h-4 mr-2" /> Create New Course
                        </Button>
                      </Link>
                    </div>
                  </div>
    </div>
  );
}
